import React, { useMemo } from 'react';

type Props = {
  lines: string | string[];
  separator?: string;
};
export function NlToBr({ lines, separator }: Props) {
  const __lines: string[] = useMemo(() => {
    let _lines: string[] = [];
    if (typeof lines === 'string') {
      const _separator = separator || '\n';
      _lines = lines.split(_separator);
    } else if (lines && lines.length > 0) {
      _lines = lines;
    }
    return _lines;
  }, [lines]);
  return (
    <div className="wrap-anywhere">
      {__lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}<br />
        </React.Fragment>
      ))}
    </div>
  );
}
